import * as React from 'react';

import { VariantProps, cva } from 'class-variance-authority';

import { cn } from '../lib';

const variants = cva('', {
  variants: {
    variant: {
      default:
        'transition-border flex min-h-[80px] w-full rounded-[10px] border border-transparent bg-base-500 p-[15px] text-base leading-5 text-white outline-none duration-200 ease-in-out placeholder:text-base-300 hover:border-carbon focus:border-primary focus:hover:border-primary focus-visible:border-primary disabled:cursor-not-allowed disabled:opacity-50',
      secondary:
        'bg-base-300 px-4 py-6 placeholder:text-base-300 border border-transparent rounded-2xl outline-none w-full text-base',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

interface TextareaProps
  extends React.ComponentProps<'textarea'>,
  VariantProps<typeof variants> {
  error?: string;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, variant, ...props }, ref) => {
    return (
      <textarea
        className={cn(variants({ className, variant }))}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
